/* eslint-disable */

/** unique or primary key constraints on table "argo.user_badge" */
export enum ArgoUserBadgeConstraint {
  /** unique or primary key constraint on columns "user_badge_id" */
  UserBadgePkey = 'user_badge_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserBadgeUserIdKey = 'user_badge_user_id_key'
}

/** select columns of table "argo.user_badge" */
export enum ArgoUserBadgeSelectColumn {
  /** column name */
  BadgeId = 'badge_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.user_badge" */
export enum ArgoUserBadgeUpdateColumn {
  /** column name */
  BadgeId = 'badge_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

